"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitProof = exports.releaseDeed = exports.transferRegistrars = exports.renew = exports.register = exports.commit = exports.makeCommitment = exports.getMinimumCommitmentAge = exports.getRentPrice = exports.reclaim = exports.transferOwner = exports.isDNSRegistrar = exports.getDNSEntry = exports.getEntry = exports.getPermanentRegistrarController = exports.getPermanentRegistrar = exports.getLegacyAuctionRegistrar = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _ens = require("./ens");

var _web = require("./web3");

var _ethers = require("ethers");

var _HashRegistrar = require("@ensdomains/ens/build/contracts/HashRegistrar");

var _Deed = require("@ensdomains/ens/build/contracts/Deed");

var _BaseRegistrarImplementation = require("@ensdomains/ethregistrar/build/contracts/BaseRegistrarImplementation");

var _ETHRegistrarController = require("@ensdomains/ethregistrar/build/contracts/ETHRegistrarController");

var _interfaces = require("./constants/interfaces");

var _labelhash = require("./utils/labelhash");

var _dnsregistrar = _interopRequireDefault(require("@ensdomains/dnsregistrar"));

var legacyRegistrarInterfaceId = _interfaces.interfaces.legacyRegistrar,
    permanentRegistrarInterfaceId = _interfaces.interfaces.permanentRegistrar;
var ethRegistrar;
var dnsRegistrar;
var permanentRegistrar;
var permanentRegistrarController;
var migrationLockPeriod;
var gracePeriod;

var getEthResolver =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee() {
    var _ref2, ENS, resolverAddr;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _ens.getENS)();

          case 2:
            _ref2 = _context.sent;
            ENS = _ref2.ENS;
            _context.next = 6;
            return ENS.resolver((0, _ens.getNamehash)('eth'));

          case 6:
            resolverAddr = _context.sent;
            return _context.abrupt("return", (0, _ens.getResolverContract)(resolverAddr));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getEthResolver() {
    return _ref.apply(this, arguments);
  };
}();

var getDeed =
/*#__PURE__*/
function () {
  var _ref3 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee2(address) {
    var signer;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _web.getSignerOrProvider)();

          case 2:
            signer = _context2.sent;
            return _context2.abrupt("return", new _ethers.Contract(address, _Deed.abi, signer));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getDeed(_x) {
    return _ref3.apply(this, arguments);
  };
}();

var getLegacyAuctionRegistrar =
/*#__PURE__*/
function () {
  var _ref4 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee3() {
    var _ref5, Resolver, signer, legacyAuctionRegistrarAddress;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!ethRegistrar) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", {
              ethRegistrar: ethRegistrar
            });

          case 2:
            _context3.prev = 2;
            _context3.next = 5;
            return getEthResolver();

          case 5:
            _ref5 = _context3.sent;
            Resolver = _ref5.Resolver;
            _context3.next = 9;
            return (0, _web.getSignerOrProvider)();

          case 9:
            signer = _context3.sent;
            _context3.next = 12;
            return Resolver.interfaceImplementer((0, _ens.getNamehash)('eth'), legacyRegistrarInterfaceId);

          case 12:
            legacyAuctionRegistrarAddress = _context3.sent;
            ethRegistrar = new _ethers.Contract(legacyAuctionRegistrarAddress, _HashRegistrar.abi, signer);
            return _context3.abrupt("return", {
              ethRegistrar: ethRegistrar
            });

          case 17:
            _context3.prev = 17;
            _context3.t0 = _context3["catch"](2);

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 17]]);
  }));

  return function getLegacyAuctionRegistrar() {
    return _ref4.apply(this, arguments);
  };
}();

exports.getLegacyAuctionRegistrar = getLegacyAuctionRegistrar;

var getPermanentRegistrar =
/*#__PURE__*/
function () {
  var _ref6 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee4() {
    var _ref7, ENS, signer, ethAddr;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!permanentRegistrar) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return", {
              permanentRegistrar: permanentRegistrar
            });

          case 2:
            _context4.prev = 2;
            _context4.next = 5;
            return (0, _ens.getENS)();

          case 5:
            _ref7 = _context4.sent;
            ENS = _ref7.ENS;
            _context4.next = 9;
            return (0, _web.getSignerOrProvider)();

          case 9:
            signer = _context4.sent;
            _context4.next = 12;
            return ENS.owner((0, _ens.getNamehash)('eth'));

          case 12:
            ethAddr = _context4.sent;
            permanentRegistrar = new _ethers.Contract(ethAddr, _BaseRegistrarImplementation.abi, signer);
            return _context4.abrupt("return", {
              permanentRegistrar: permanentRegistrar
            });

          case 17:
            _context4.prev = 17;
            _context4.t0 = _context4["catch"](2);

          case 19:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[2, 17]]);
  }));

  return function getPermanentRegistrar() {
    return _ref6.apply(this, arguments);
  };
}();

exports.getPermanentRegistrar = getPermanentRegistrar;

var getPermanentRegistrarController =
/*#__PURE__*/
function () {
  var _ref8 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee5() {
    var _ref9, Resolver, signer, controllerAddress;

    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!permanentRegistrarController) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return", {
              permanentRegistrarController: permanentRegistrarController
            });

          case 2:
            _context5.prev = 2;
            _context5.next = 5;
            return getEthResolver();

          case 5:
            _ref9 = _context5.sent;
            Resolver = _ref9.Resolver;
            _context5.next = 9;
            return (0, _web.getSignerOrProvider)();

          case 9:
            signer = _context5.sent;
            _context5.next = 12;
            return Resolver.interfaceImplementer((0, _ens.getNamehash)('eth'), permanentRegistrarInterfaceId);

          case 12:
            controllerAddress = _context5.sent;
            permanentRegistrarController = new _ethers.Contract(controllerAddress, _ETHRegistrarController.abi, signer);
            return _context5.abrupt("return", {
              permanentRegistrarController: permanentRegistrarController
            });

          case 17:
            _context5.prev = 17;
            _context5.t0 = _context5["catch"](2);
            console.log('error getting permanent registrar controller', _context5.t0);

          case 20:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[2, 17]]);
  }));

  return function getPermanentRegistrarController() {
    return _ref8.apply(this, arguments);
  };
}();

exports.getPermanentRegistrarController = getPermanentRegistrarController;

var getLegacyEntry =
/*#__PURE__*/
function () {
  var _ref10 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee6(Registrar, name) {
    var obj, _ref11, _Registrar, deedOwner, entry, deed;

    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return getLegacyAuctionRegistrar();

          case 3:
            _ref11 = _context6.sent;
            _Registrar = _ref11.ethRegistrar;
            deedOwner = '0x0';
            _context6.next = 8;
            return _Registrar.entries((0, _labelhash.labelhash)(name));

          case 8:
            entry = _context6.sent;

            if (!(parseInt(entry[1], 16) !== 0)) {
              _context6.next = 16;
              break;
            }

            _context6.next = 12;
            return getDeed(entry[1]);

          case 12:
            deed = _context6.sent;
            _context6.next = 15;
            return deed.owner();

          case 15:
            deedOwner = _context6.sent;

          case 16:
            obj = {
              deedOwner: deedOwner,
              state: parseInt(entry[0]),
              registrationDate: parseInt(entry[2]) * 1000,
              revealDate: (parseInt(entry[2]) - 24 * 2 * 60 * 60) * 1000,
              value: parseInt(entry[3]),
              highestBid: parseInt(entry[4])
            };
            _context6.next = 22;
            break;

          case 19:
            _context6.prev = 19;
            _context6.t0 = _context6["catch"](0);
            obj = {
              deedOwner: '0x0',
              state: 0,
              registrationDate: 0,
              revealDate: 0,
              value: 0,
              highestBid: 0,
              expiryTime: 0,
              error: _context6.t0.message
            };

          case 22:
            return _context6.abrupt("return", obj);

          case 23:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 19]]);
  }));

  return function getLegacyEntry(_x2, _x3) {
    return _ref10.apply(this, arguments);
  };
}(); // Caching because they are constant


function getMigrationLockPeriod(_x4) {
  return _getMigrationLockPeriod.apply(this, arguments);
}

function _getMigrationLockPeriod() {
  _getMigrationLockPeriod = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee22(Registrar) {
    return _regenerator["default"].wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            if (migrationLockPeriod) {
              _context22.next = 2;
              break;
            }

            return _context22.abrupt("return", Registrar.MIGRATION_LOCK_PERIOD());

          case 2:
            return _context22.abrupt("return", migrationLockPeriod);

          case 3:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _getMigrationLockPeriod.apply(this, arguments);
}

function getGracePeriod(_x5) {
  return _getGracePeriod.apply(this, arguments);
}

function _getGracePeriod() {
  _getGracePeriod = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee23(Registrar) {
    return _regenerator["default"].wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            if (gracePeriod) {
              _context23.next = 2;
              break;
            }

            return _context23.abrupt("return", Registrar.GRACE_PERIOD());

          case 2:
            return _context23.abrupt("return", gracePeriod);

          case 3:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
  return _getGracePeriod.apply(this, arguments);
}

function getOwnerOf(_x6, _x7) {
  return _getOwnerOf.apply(this, arguments);
}

function _getOwnerOf() {
  _getOwnerOf = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee24(Registrar, labelHash) {
    return _regenerator["default"].wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            _context24.prev = 0;
            return _context24.abrupt("return", Registrar.ownerOf(labelHash));

          case 4:
            _context24.prev = 4;
            _context24.t0 = _context24["catch"](0);
            return _context24.abrupt("return", '0x0');

          case 7:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24, null, [[0, 4]]);
  }));
  return _getOwnerOf.apply(this, arguments);
}

var getPermanentEntry =
/*#__PURE__*/
function () {
  var _ref12 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee7(Registrar, RegistrarController, label) {
    var getAvailable, obj, labelHash, _ref13, _ref14, available, transferPeriodEnds, nameExpires, _gracePeriod, _migrationLockPeriod;

    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            obj = {
              available: null,
              nameExpires: null
            };
            _context7.prev = 1;
            labelHash = (0, _labelhash.labelhash)(label); // Returns true if name is available

            if ((0, _labelhash.isEncodedLabelhash)(label)) {
              getAvailable = Registrar.available(labelHash);
            } else {
              getAvailable = RegistrarController.available(label);
            }

            _context7.next = 6;
            return Promise.all([getAvailable, Registrar.transferPeriodEnds(), Registrar.nameExpires(labelHash), getGracePeriod(Registrar), getMigrationLockPeriod(Registrar)]);

          case 6:
            _ref13 = _context7.sent;
            _ref14 = (0, _slicedToArray2["default"])(_ref13, 5);
            available = _ref14[0];
            transferPeriodEnds = _ref14[1];
            nameExpires = _ref14[2];
            _gracePeriod = _ref14[3];
            _migrationLockPeriod = _ref14[4];
            obj = (0, _objectSpread2["default"])({}, obj, {
              migrationLockPeriod: parseInt(_migrationLockPeriod),
              available: available,
              gracePeriod: _gracePeriod,
              transferPeriodEnds: transferPeriodEnds,
              nameExpires: nameExpires > 0 ? new Date(nameExpires * 1000) : null // Returns registrar address if owned by new registrar.
              // Keep it as a separate call as this will throw exception for non existing domains

            });
            _context7.next = 16;
            return Registrar.ownerOf(labelHash);

          case 16:
            obj.ownerOf = _context7.sent;
            _context7.next = 23;
            break;

          case 19:
            _context7.prev = 19;
            _context7.t0 = _context7["catch"](1);
            console.log('Error getting permanent registrar entry', _context7.t0);
            return _context7.abrupt("return", false);

          case 23:
            _context7.prev = 23;
            return _context7.abrupt("return", obj);

          case 26:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[1, 19, 23, 26]]);
  }));

  return function getPermanentEntry(_x8, _x9, _x10) {
    return _ref12.apply(this, arguments);
  };
}();

var isDNSRegistrar =
/*#__PURE__*/
function () {
  var _ref15 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee8(name) {
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", name === 'xyz');

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function isDNSRegistrar(_x11) {
    return _ref15.apply(this, arguments);
  };
}();

exports.isDNSRegistrar = isDNSRegistrar;

var getDNSEntry =
/*#__PURE__*/
function () {
  var _ref16 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee9(name, parentOwner, owner) {
    var web3, provider, registrarjs, claim, result, proofs;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            // Do not cache as it needs to be refetched on "Refresh"
            dnsRegistrar = {};
            _context9.next = 3;
            return (0, _web.getWeb3Read)();

          case 3:
            web3 = _context9.sent;
            provider = web3._web3Provider;
            registrarjs = new _dnsregistrar["default"](provider, parentOwner);
            _context9.prev = 6;
            _context9.next = 9;
            return registrarjs.claim(name);

          case 9:
            claim = _context9.sent;
            result = claim.getResult();
            dnsRegistrar.claim = claim;
            dnsRegistrar.result = result;

            if (!result.found) {
              _context9.next = 19;
              break;
            }

            proofs = result.proofs;
            dnsRegistrar.dnsOwner = claim.getOwner();

            if (!dnsRegistrar.dnsOwner) {
              // DNS Record is invalid
              dnsRegistrar.state = 4;
            } else {
              // Valid reacord is found
              if (!owner || dnsRegistrar.dnsOwner.toLowerCase() === owner.toLowerCase()) {
                dnsRegistrar.state = 5; // Out of sync
              } else {
                dnsRegistrar.state = 6;
              }
            }

            _context9.next = 32;
            break;

          case 19:
            if (!result.nsec) {
              _context9.next = 31;
              break;
            }

            if (!(result.results.length === 4)) {
              _context9.next = 24;
              break;
            } // DNS entry does not exist


            dnsRegistrar.state = 1;
            _context9.next = 29;
            break;

          case 24:
            if (!(result.results.length === 6)) {
              _context9.next = 28;
              break;
            } // DNS entry exists but _ens subdomain does not exist


            dnsRegistrar.state = 3;
            _context9.next = 29;
            break;

          case 28:
            throw "DNSSEC results cannot be ".concat(result.results.length);

          case 29:
            _context9.next = 32;
            break;

          case 31:
            // DNSSEC is not enabled
            dnsRegistrar.state = 2;

          case 32:
            _context9.next = 38;
            break;

          case 34:
            _context9.prev = 34;
            _context9.t0 = _context9["catch"](6);
            console.log('Problem fetching data from DNS', _context9.t0); // Problem fetching data from DNS

            dnsRegistrar.state = 0;

          case 38:
            return _context9.abrupt("return", dnsRegistrar);

          case 39:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[6, 34]]);
  }));

  return function getDNSEntry(_x12, _x13, _x14) {
    return _ref16.apply(this, arguments);
  };
}();

exports.getDNSEntry = getDNSEntry;

var getEntry =
/*#__PURE__*/
function () {
  var _ref17 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee10(name) {
    var _ref18, _ref19, AuctionRegistrar, Registrar, RegistrarController, _ref20, _ref21, block, legacyEntry, permEntry, ret, currentTime, gracePeriodEndDate;

    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return Promise.all([getLegacyAuctionRegistrar(), getPermanentRegistrar(), getPermanentRegistrarController()]);

          case 2:
            _ref18 = _context10.sent;
            _ref19 = (0, _slicedToArray2["default"])(_ref18, 3);
            AuctionRegistrar = _ref19[0].ethRegistrar;
            Registrar = _ref19[1].permanentRegistrar;
            RegistrarController = _ref19[2].permanentRegistrarController;
            _context10.next = 9;
            return Promise.all([(0, _web.getBlock)(), getLegacyEntry(AuctionRegistrar, name), getPermanentEntry(Registrar, RegistrarController, name)]);

          case 9:
            _ref20 = _context10.sent;
            _ref21 = (0, _slicedToArray2["default"])(_ref20, 3);
            block = _ref21[0];
            legacyEntry = _ref21[1];
            permEntry = _ref21[2];
            ret = {
              currentBlockDate: new Date(block.timestamp * 1000),
              registrant: 0,
              transferEndDate: null,
              isNewRegistrar: false,
              gracePeriodEndDate: null
            };

            if (permEntry) {
              if (legacyEntry.registrationDate && permEntry.migrationLockPeriod) {
                ret.migrationStartDate = new Date(legacyEntry.registrationDate + permEntry.migrationLockPeriod * 1000);
              } else {
                ret.migrationStartDate = null;
              }

              if (permEntry.transferPeriodEnds) {
                ret.transferEndDate = new Date(permEntry.transferPeriodEnds * 1000);
              }

              ret.available = permEntry.available;

              if (!permEntry.available) {
                // Owned
                ret.state = 2;
              }

              if (permEntry.nameExpires) {
                ret.expiryTime = permEntry.nameExpires;
              }

              if (permEntry.ownerOf) {
                ret.registrant = permEntry.ownerOf;
                ret.isNewRegistrar = true;
              } else if (permEntry.nameExpires) {
                currentTime = new Date(ret.currentBlockDate);
                gracePeriodEndDate = new Date(currentTime.getTime() + permEntry.gracePeriod * 1000); // It is within grace period

                if (permEntry.nameExpires < currentTime < gracePeriodEndDate) {
                  ret.isNewRegistrar = true;
                  ret.gracePeriodEndDate = gracePeriodEndDate;
                }
              }
            }

            return _context10.abrupt("return", (0, _objectSpread2["default"])({}, legacyEntry, ret));

          case 17:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function getEntry(_x15) {
    return _ref17.apply(this, arguments);
  };
}();

exports.getEntry = getEntry;

var transferOwner =
/*#__PURE__*/
function () {
  var _ref22 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee11(name, to) {
    var overrides,
        nameArray,
        labelHash,
        account,
        _ref23,
        Registrar,
        networkId,
        gas,
        _args11 = arguments;

    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            overrides = _args11.length > 2 && _args11[2] !== undefined ? _args11[2] : {};
            _context11.prev = 1;
            nameArray = name.split('.');
            labelHash = (0, _labelhash.labelhash)(nameArray[0]);
            _context11.next = 6;
            return (0, _web.getAccount)();

          case 6:
            account = _context11.sent;
            _context11.next = 9;
            return getPermanentRegistrar();

          case 9:
            _ref23 = _context11.sent;
            Registrar = _ref23.permanentRegistrar;
            _context11.next = 13;
            return (0, _web.getNetworkId)();

          case 13:
            networkId = _context11.sent;

            if (!(parseInt(networkId) > 1000)) {
              _context11.next = 19;
              break;
            }

            _context11.next = 17;
            return Registrar.estimate.safeTransferFrom(account, to, labelHash);

          case 17:
            gas = _context11.sent;
            overrides = (0, _objectSpread2["default"])({}, overrides, {
              gasLimit: gas.toNumber() * 2
            });

          case 19:
            return _context11.abrupt("return", Registrar.safeTransferFrom(account, to, labelHash, overrides));

          case 22:
            _context11.prev = 22;
            _context11.t0 = _context11["catch"](1);
            console.log('Error calling transferOwner', _context11.t0);

          case 25:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[1, 22]]);
  }));

  return function transferOwner(_x16, _x17) {
    return _ref22.apply(this, arguments);
  };
}();

exports.transferOwner = transferOwner;

var reclaim =
/*#__PURE__*/
function () {
  var _ref24 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee12(name, address) {
    var overrides,
        nameArray,
        labelHash,
        _ref25,
        Registrar,
        networkId,
        gas,
        _args12 = arguments;

    return _regenerator["default"].wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            overrides = _args12.length > 2 && _args12[2] !== undefined ? _args12[2] : {};
            _context12.prev = 1;
            nameArray = name.split('.');
            labelHash = (0, _labelhash.labelhash)(nameArray[0]);
            _context12.next = 6;
            return getPermanentRegistrar();

          case 6:
            _ref25 = _context12.sent;
            Registrar = _ref25.permanentRegistrar;
            _context12.next = 10;
            return (0, _web.getNetworkId)();

          case 10:
            networkId = _context12.sent;

            if (!(parseInt(networkId) > 1000)) {
              _context12.next = 16;
              break;
            }

            _context12.next = 14;
            return Registrar.estimate.reclaim(labelHash, address);

          case 14:
            gas = _context12.sent;
            overrides = (0, _objectSpread2["default"])({}, overrides, {
              gasLimit: gas.toNumber() * 2
            });

          case 16:
            return _context12.abrupt("return", Registrar.reclaim(labelHash, address, (0, _objectSpread2["default"])({}, overrides)));

          case 19:
            _context12.prev = 19;
            _context12.t0 = _context12["catch"](1);
            console.log('Error calling reclaim', _context12.t0);

          case 22:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[1, 19]]);
  }));

  return function reclaim(_x18, _x19) {
    return _ref24.apply(this, arguments);
  };
}();

exports.reclaim = reclaim;

var getRentPrice =
/*#__PURE__*/
function () {
  var _ref26 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee13(name, duration) {
    var _ref27, permanentRegistrarController;

    return _regenerator["default"].wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return getPermanentRegistrarController();

          case 2:
            _ref27 = _context13.sent;
            permanentRegistrarController = _ref27.permanentRegistrarController;
            return _context13.abrupt("return", permanentRegistrarController.rentPrice(name, duration));

          case 5:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function getRentPrice(_x20, _x21) {
    return _ref26.apply(this, arguments);
  };
}();

exports.getRentPrice = getRentPrice;

var getMinimumCommitmentAge =
/*#__PURE__*/
function () {
  var _ref28 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee14() {
    var _ref29, permanentRegistrarController;

    return _regenerator["default"].wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return getPermanentRegistrarController();

          case 2:
            _ref29 = _context14.sent;
            permanentRegistrarController = _ref29.permanentRegistrarController;
            return _context14.abrupt("return", permanentRegistrarController.minCommitmentAge());

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function getMinimumCommitmentAge() {
    return _ref28.apply(this, arguments);
  };
}();

exports.getMinimumCommitmentAge = getMinimumCommitmentAge;

var makeCommitment =
/*#__PURE__*/
function () {
  var _ref30 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee15(name, owner) {
    var secret,
        _ref31,
        permanentRegistrarController,
        _args15 = arguments;

    return _regenerator["default"].wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            secret = _args15.length > 2 && _args15[2] !== undefined ? _args15[2] : '';
            _context15.next = 3;
            return getPermanentRegistrarController();

          case 3:
            _ref31 = _context15.sent;
            permanentRegistrarController = _ref31.permanentRegistrarController;
            return _context15.abrupt("return", permanentRegistrarController.makeCommitment(name, owner, secret));

          case 6:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function makeCommitment(_x22, _x23) {
    return _ref30.apply(this, arguments);
  };
}();

exports.makeCommitment = makeCommitment;

var commit =
/*#__PURE__*/
function () {
  var _ref32 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee16(label) {
    var secret,
        _ref33,
        permanentRegistrarController,
        account,
        commitment,
        _args16 = arguments;

    return _regenerator["default"].wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            secret = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : '';
            _context16.next = 3;
            return getPermanentRegistrarController();

          case 3:
            _ref33 = _context16.sent;
            permanentRegistrarController = _ref33.permanentRegistrarController;
            _context16.next = 7;
            return (0, _web.getAccount)();

          case 7:
            account = _context16.sent;
            _context16.next = 10;
            return makeCommitment(label, account, secret);

          case 10:
            commitment = _context16.sent;
            return _context16.abrupt("return", permanentRegistrarController.commit(commitment));

          case 12:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));

  return function commit(_x24) {
    return _ref32.apply(this, arguments);
  };
}();

exports.commit = commit;

var register =
/*#__PURE__*/
function () {
  var _ref34 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee17(label, duration, secret) {
    var _ref35, permanentRegistrarController, account, price;

    return _regenerator["default"].wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return getPermanentRegistrarController();

          case 2:
            _ref35 = _context17.sent;
            permanentRegistrarController = _ref35.permanentRegistrarController;
            _context17.next = 6;
            return (0, _web.getAccount)();

          case 6:
            account = _context17.sent;
            _context17.next = 9;
            return getRentPrice(label, duration);

          case 9:
            price = _context17.sent;
            return _context17.abrupt("return", permanentRegistrarController.register(label, account, duration, secret, {
              value: price
            }));

          case 11:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));

  return function register(_x25, _x26, _x27) {
    return _ref34.apply(this, arguments);
  };
}();

exports.register = register;

var renew =
/*#__PURE__*/
function () {
  var _ref36 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee18(label, duration) {
    var _ref37, permanentRegistrarController, price;

    return _regenerator["default"].wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.next = 2;
            return getPermanentRegistrarController();

          case 2:
            _ref37 = _context18.sent;
            permanentRegistrarController = _ref37.permanentRegistrarController;
            _context18.next = 6;
            return getRentPrice(label, duration);

          case 6:
            price = _context18.sent;
            return _context18.abrupt("return", permanentRegistrarController.renew(label, duration, {
              value: price
            }));

          case 8:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));

  return function renew(_x28, _x29) {
    return _ref36.apply(this, arguments);
  };
}();

exports.renew = renew;

var transferRegistrars =
/*#__PURE__*/
function () {
  var _ref38 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee19(label) {
    var _ref39, ethRegistrar, hash;

    return _regenerator["default"].wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.next = 2;
            return getLegacyAuctionRegistrar();

          case 2:
            _ref39 = _context19.sent;
            ethRegistrar = _ref39.ethRegistrar;
            hash = (0, _labelhash.labelhash)(label);
            return _context19.abrupt("return", ethRegistrar.transferRegistrars(hash));

          case 6:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));

  return function transferRegistrars(_x30) {
    return _ref38.apply(this, arguments);
  };
}();

exports.transferRegistrars = transferRegistrars;

var releaseDeed =
/*#__PURE__*/
function () {
  var _ref40 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee20(label) {
    var _ref41, ethRegistrar, hash;

    return _regenerator["default"].wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.next = 2;
            return getLegacyAuctionRegistrar();

          case 2:
            _ref41 = _context20.sent;
            ethRegistrar = _ref41.ethRegistrar;
            hash = (0, _labelhash.labelhash)(label);
            return _context20.abrupt("return", ethRegistrar.releaseDeed(hash));

          case 6:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));

  return function releaseDeed(_x31) {
    return _ref40.apply(this, arguments);
  };
}();

exports.releaseDeed = releaseDeed;

var submitProof =
/*#__PURE__*/
function () {
  var _ref42 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee21(name, parentOwner) {
    var _ref43, claim, result, _ref44, registrar, data, allProven;

    return _regenerator["default"].wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.next = 2;
            return getDNSEntry(name, parentOwner);

          case 2:
            _ref43 = _context21.sent;
            claim = _ref43.claim;
            result = _ref43.result;
            _context21.next = 7;
            return (0, _ens.getDnsRegistrarContract)(parentOwner);

          case 7:
            _ref44 = _context21.sent;
            registrar = _ref44.registrar;
            _context21.next = 11;
            return claim.oracle.getAllProofs(result, {});

          case 11:
            data = _context21.sent;
            _context21.next = 14;
            return claim.oracle.allProven(result);

          case 14:
            allProven = _context21.sent;

            if (!allProven) {
              _context21.next = 19;
              break;
            }

            return _context21.abrupt("return", registrar.claim(claim.encodedName, data[1]));

          case 19:
            return _context21.abrupt("return", registrar.proveAndClaim(claim.encodedName, data[0], data[1]));

          case 20:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));

  return function submitProof(_x32, _x33) {
    return _ref42.apply(this, arguments);
  };
}();

exports.submitProof = submitProof;